import React from "react";
import PostGrid from "../components/postsGrid/PostGrid";
import Sidebar from "../components/sidebar/Sidebar";

const Home = () => {
  return (
    <section className="wrapper">
      <Sidebar />
      <PostGrid />
    </section>
  );
};

export default Home;
